
export default class SendFormReportRequest {

    public id: string = "";

    public emailReceivers: string = "";
}